import React from 'react';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import BillProductsFormContainer from './BillProductsFormContainer';
import PropTypes from 'prop-types';
import Card from '../../../core/layout/Card';
import get from 'lodash/get';
import DateInput from '../../../core/form/DateInput';
import TextInput from '../../../core/form/TextInput';
import Separator from '../../../core/layout/Separator';
import FormButtons from '../../../core/form/FormButtons';
import BillProductsListContainer from './BillProductsListContainer';
import ContractSelectContainer from './BillContractSelectContainer';
import Button from '../../../core/form/Button';
import { browserHistory } from 'react-router';
import { realCurrencyFormatter, dollarCurrencyFormatter } from '../../../core/consts';
import LocalFileInput from '../../../core/form/LocalFileInput';

const BillForm = (props) => (
  <form
    onSubmit={(event) => {
      event.preventDefault();
      props.onSubmit();
    }}
  >
    <Card
      title={get(props.values, 'id', null) ? 'Update Bill' : 'Create Bill'}
      actions={<Button icon="arrow-left" label="Back" type="default" onClick={() => browserHistory.goBack()} />}
    >
      <Row>
        <Column size={4}>
          <ContractSelectContainer
            loading={props.loading}
            submitting={props.submitting}
            values={props.values}
            errors={props.errors}
            onChange={props.onChange}
            required
          />
        </Column>
        <Column size={4}>
          <TextInput
            required
            disabled
            label="Social Reason"
            value={get(props.values, 'socialReason', '')}
            onChange={(value) => props.onChange('socialReason', (value || '').toLowerCase())}
            errorText={get(props.errors, 'socialReason', null)}
          />
        </Column>
        <Column size={3}>
          <LocalFileInput
            value={get(props.values, 'bankBillFile', null) || get(props.values, 'bankBillUrl', null)}
            onChange={(value) => props.onChange('bankBillFile', value)}
            label="Payment Slip"
            accept="pdf"
            disabled={props.submitting || props.loading}
          />
        </Column>
      </Row>
      <Row>
        <Column size={2}>
          <DateInput
            disabled={props.submitting || props.loading}
            required
            label="Due date"
            value={get(props.values, 'dueDate', null)}
            onChange={(value) => props.onChange('dueDate', value)}
            errorText={get(props.errors, 'dueDate', '')}
          />
        </Column>
        <Column size={2}>
          <DateInput
            disabled={props.submitting || props.loading}
            required
            label="Reference Date From"
            value={get(props.values, 'referenceDateFrom', null)}
            onChange={(value) => props.onChange('referenceDateFrom', value)}
            errorText={get(props.errors, 'referenceDateFrom', '')}
          />
        </Column>
        <Column size={2}>
          <DateInput
            disabled={props.submitting || props.loading}
            required
            label="Reference Date To"
            value={get(props.values, 'referenceDateTo', null)}
            onChange={(value) => props.onChange('referenceDateTo', value)}
            errorText={get(props.errors, 'referenceDateTo', '')}
          />
        </Column>
      </Row>
    </Card>
    <Separator />
    <Card title="Bill's Products">
      <BillProductsFormContainer />
      <BillProductsListContainer />
      <div style={{ textAlign: 'right', fontSize: 18, fontWeight: 'bold' }}>
        <span>
          Total Price:{' '}
          {props.currencyType === 'real'
            ? realCurrencyFormatter.format(props.total)
            : dollarCurrencyFormatter.format(props.total)}
        </span>
      </div>
    </Card>
    <Separator />
    <FormButtons
      confirmLabel={`${get(props.values, 'id') ? 'Update' : 'Create'} Bill`}
      isDisabled={props.submitting || props.loading}
      isSubmitting={props.submitting}
      onReset={props.onReset}
    />
  </form>
);

BillForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onReset: PropTypes.func,
  values: PropTypes.object,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  loading: PropTypes.bool,
  total: PropTypes.number,
  currencyType: PropTypes.oneOf(['real', 'dollar']),
};

BillForm.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  loading: false,
  onReset: () => false,
  total: 0,
  currencyType: 'real',
};

export default BillForm;
